/**
 * @see https://github.com/agraboso/redux-api-middleware
 */
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { reducers } from '../reducers'

const initialState = {}
const middleware = [thunk]

const store = createStore(
  reducers,
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f // compose expect a function here, not a boolean
  )
)
export default store
